import { Admin, CustomRoutes } from "react-admin";
import { Navigate, Route, useLocation } from "react-router-dom";
import { Layout } from "./Layout";
import { theme } from "./theme";
import { dataProvider } from "./dataProvider";
import { authProvider } from "./backoffice/authProvider";
import { LoginPage, ChangePasswordPage } from "./backoffice/AuthUI";
import {
  TransactionsPage,
  TransactionDetail,
  SessionsPage,
  SessionDetail,
  PlayersPage,
  PlayerDetail,
  GamesPage,
  GameDetail,
} from "./backoffice/EntityPages";
import { UsersPage } from "./backoffice/UsersPage";
import { crashResources } from "./modules/crash/CrashResources";

const Home = () => <Navigate to="/transactions" replace />;
function LegacyRedirect() {
  const { pathname, search } = useLocation();
  return <Navigate to={`/crash${pathname}${search}`} replace />;
}
// Layout's SessionGate protects every page and preserves the login return path.
// Using Admin's requireAuth as well triggers a logout/query-reset loop with Router 7.
export const App = () => (
  <Admin
    title="Algol Backoffice"
    layout={Layout}
    theme={theme}
    darkTheme={theme}
    dataProvider={dataProvider}
    authProvider={authProvider}
    loginPage={LoginPage}
    dashboard={Home}
  >
    {crashResources}
    <CustomRoutes>
      <Route path="/transactions" element={<TransactionsPage />} />
      <Route path="/transactions/:id" element={<TransactionDetail />} />
      <Route path="/sessions" element={<SessionsPage />} />
      <Route path="/sessions/:id" element={<SessionDetail />} />
      <Route path="/players" element={<PlayersPage />} />
      <Route path="/players/:id" element={<PlayerDetail />} />
      <Route path="/games" element={<GamesPage />} />
      <Route path="/games/:id" element={<GameDetail />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route path="/crash" element={<Navigate to="/crash/fdb" replace />} />
      {[
        "db-rounds",
        "db-bets",
        "db-wallet-requests",
        "db-game-configs",
        "db-operators",
        "db-users",
        "fdb",
        "recon",
        "operator-stats",
      ].map((path) => (
        <Route key={path} path={`/${path}/*`} element={<LegacyRedirect />} />
      ))}
    </CustomRoutes>
  </Admin>
);
